// import { useModal } from '@ebay/nice-modal-react'
// import { cx } from '@linaria/core'
import { styled } from '@linaria/react'
// import type { MouseEvent } from 'react'
import React, { useRef } from 'react'

// import { useOnClickOutside } from '../../hooks/useOnClickOutside'
// import useRefreshBalance from '../../hooks/useRefreshBalance'
import { useBoundStore } from '../../store/store'
// import type { ApiResponse } from '../../types/api'
// import { api } from '../../utils/api-client'
import { numberWithCommas } from '../../utils/number'
// import Icon from '../icon'
// import { Spinner, ToastMessage } from '.'

// const Dropdown = styled.div`
//   position: absolute;
//   top: 45px;
//   right: -25px;
//   z-index: 10;
//   padding: 10px;
//   border-radius: 6px;
//   box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.2);
//   background-color: var(--primary);
//   width: 280px;
//   transition: all 0.3s ease;
//   transform: translateY(-20px);
//   opacity: 0;
//   pointer-events: none;
//   &.active {
//     opacity: 1;
//     transform: translateY(0);
//     pointer-events: auto;
//   }
//   @media (min-width: 1200px) {
//     top: 48px;
//     right: 0;
//     width: 300px;
//   }
// `

// const Row = styled.div`
//   background-color: var(--secondary);
//   border-radius: 4px;
//   margin-bottom: 10px;
//   padding: 6px 12px;
//   color: var(--txt);
//   &:last-child {
//     margin-bottom: 0;
//   }
//   .label {
//     font-size: 14px;
//     margin-left: 6px;
//   }
//   .icon {
//     width: 25px;
//     height: 25px;
//   }
//   .amount {
//     font-size: 14px;
//     font-weight: 600;
//   }
//   @media (min-width: 1200px) {
//     .icon {
//       width: 30px;
//       height: 30px;
//     }
//     .label,
//     .amount {
//       font-size: 16px;
//     }
//   }
// `

const Balance = styled.span`
  font-size: 16px;
  font-weight: 400;
  color: var(--txt);
  cursor: pointer;
  margin-right: 7px;
  .arrow {
    margin-left: 5px;
    transition: 0.2s linear;
    transform: rotate(0deg);
    &.active {
      transform: rotate(180deg);
    }
  }
`

const BalanceBreakdown = () => {
  // const { refreshBalance } = useRefreshBalance()
  const ref = useRef<HTMLDivElement>(null)
  // const toastMessage = useModal(ToastMessage)
  const realBalance = useBoundStore(state => state.user.unified_balance)
  // const showBalance = useBoundStore(state => state.user.show_balance)
  // const promoBalance = useBoundStore(state => state.user.promo_balance)
  // const [isLoading, setIsLoading] = useState(false)
  // const [isVisible, setIsVisible] = useState(false)

  // useOnClickOutside(ref, () => {
  //   setIsVisible(false)
  // })

  // const claim = async (e: MouseEvent) => {
  //   e.stopPropagation()
  //   try {
  //     setIsLoading(true)
  //     const res = await api.post<ApiResponse<string>>('/ajax_data.php', {
  //       type: 'claim_bonus',
  //       action: 1,
  //     })
  //     const { info, status } = res.data
  //     toastMessage.show({
  //       text: info,
  //       isValid: status === 1,
  //     })
  //     if (status === 1) {
  //       refreshBalance()
  //     }
  //   } catch (error) {
  //     console.error(error)
  //   }
  //   setIsLoading(false)
  // }

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <Balance
        className="flx-str-ctr"
        onClick={e => {
          e.stopPropagation()
          // setIsVisible(prev => !prev)
        }}>
        ${numberWithCommas(realBalance)}
        {/* <Icon
          className={cx('arrow', isVisible && 'active')}
          id="triangle-down"
          width={12}
          height={12}
        /> */}
      </Balance>
      {/* <Dropdown className={cx(isVisible && 'active')}>
        <Row className="flx-btw-ctr">
          <div className="flx-str-ctr">
            <svg
              className="icon"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512">
              <path
                fill="currentColor"
                d="m264.37,327.92c-.13-1.16-.1-2.41-.06-3.74.05-1.65.1-3.36-.18-5.11l-.11-.71c-.52-3.39-1.1-7.23-3-10.38-1.65-2.74-1.61-4.47.2-8.08,2.22-4.43,4.03-7.02,7.74-8.86,20.53-10.19,29.83-25.43,28.43-46.59-.94-14.16-6.7-24.92-17.6-32.88-4.24-3.09-8.87-5.75-12.95-8.1-1.26-.72-2.46-1.42-3.62-2.1.1-1.75.19-3.47.27-5.17.25-4.86.49-9.45.9-14.06,1.36-15.28-5.08-27.45-19.7-37.21-14.48-9.66-31.37-15.43-54.77-18.72-8.73-1.23-17.43-1.85-25.87-1.85-22.91,0-45.08,4.59-65.87,13.63-10.51,4.57-21.98,10.83-27.33,22.58-3.36,7.38-7.93,11.98-15.28,15.37-.29.13-.55.28-.79.44-22.42,15.08-24.23,30.79-19.72,54.48,2.05,10.75,10.02,17.5,17.55,22.69,3.74,2.57,7.6,4.72,11.7,7,1.16.65,2.33,1.3,3.51,1.96-2.82,10.01-1.96,19.97-1.12,29.63l.05.54c.22,2.5,1.4,4.78,2.44,6.8.93,1.79,1.8,3.48,1.8,4.86,0,1.46-.89,3.22-1.84,5.08-1.02,2-2.07,4.07-2.41,6.42-.62,4.27-.59,8.61-.57,12.8.01,1.96.02,3.98-.03,5.94-.26,8.91,2.99,16.99,9.66,24.02,8.43,8.89,19.61,15.49,34.2,20.18,18.4,5.91,36.92,8.91,55.04,8.91,8.3,0,16.69-.63,24.95-1.86,14.41-2.16,33.15-5.92,50.32-15.95,18.24-10.65,26.11-24.38,24.07-41.97Zm-184.57-110.17c15.82,13.31,34.92,18.48,49.8,21.49,9.78,1.98,20.2,3.13,31.65,3.5-9.95,1.69-19.77,2.54-29.3,2.54-18.63,0-36.91-3.25-54.34-9.67-9.83-3.62-17.53-8.34-23.54-14.43-4.58-4.64-6.88-9.25-6.83-13.7.05-4.31,2.32-8.66,6.73-12.93,3.04-2.94,6.51-5.42,10.18-8.04.58-.41,1.17-.83,1.76-1.26,0,.86,0,1.7-.05,2.54-.61,11.58,4.08,21.67,13.94,29.96Zm3.31,64.11c-3.72-5.02-4.52-9.8-2.38-14.23l3.29.72c6.23,1.36,12.67,2.76,18.97,4.19.19.04.5.23.59.34,11.27,15.62,28.22,22.47,43.32,27.11,14.98,4.61,30.62,6.91,47.75,7.01-10.69,1.79-21.11,2.69-31.03,2.69h0c-20.64,0-40.32-3.93-58.51-11.69-10.02-4.27-17-9.4-21.99-16.14Zm114.64-4.33h0c-12.9,0-26.01-1.56-39.11-4.66,2.72-.38,5.39-.79,8.09-1.28,21.37-3.92,36.64-10.05,49.51-19.89,7.97-6.09,12.98-13.05,15.31-21.23.21-.45,1.47-1.35,2.07-1.78l.19-.13c7.81-5.58,14.67-10.38,20.99-14.68.24-.17.73-.33,1.03-.35,7.58,3.25,16.17,7.62,22.59,15.3,6.47,7.72,6.48,14.58.05,22.23-7.25,8.63-17.22,14.53-32.31,19.14-15.94,4.86-32.22,7.32-48.4,7.32Zm47.14-89.27c-9.16,9.63-21.36,14.45-30.96,17.56-14.66,4.76-30.13,7.07-47.27,7.07-.46,0-.93,0-1.39,0-28.44-.21-49.13-4.91-67.07-15.22-5.22-3-10.41-7.37-15.01-12.65-6.45-7.4-3.56-14.63,0-19.38,5.63-7.53,13.63-13.13,24.45-17.13,19.54-7.21,39.08-10.87,58.08-10.87,20.64,0,41.22,4.32,61.17,12.83,5.67,2.42,11.62,6.51,17.68,12.15,4.19,3.9,6.38,8.02,6.51,12.25.13,4.42-1.95,8.92-6.19,13.38Zm-164.18,127.18c21.98,16.08,48.89,23.61,84.37,23.65h.36c35.14,0,61.98-7.55,84.15-23.72,2.42,5.21,1.61,9.89-2.49,15.2-5.89,7.62-14.15,13.13-26.76,17.89-16.97,6.39-34.54,9.5-53.74,9.5h0c-9.94,0-20.44-.88-31.18-2.6-15.28-2.46-28.1-6.95-39.22-13.73-5.08-3.1-11.36-7.55-14.92-14.51-2.14-4.2-2.34-7.97-.56-11.68Z"
              />
              <path
                fill="currentColor"
                d="m291.23,215.35l1.73,3.9c.64,1.45,1.32,2.85,1.98,4.21,1.45,2.99,2.81,5.81,3.59,8.7,1.45,5.36,4.88,6.09,8.36,6.09h.12c14.09-.06,28.04-.06,38.61-.06h34.29s24.89,0,24.89,0c6.47,0,12.94,0,19.4.01,1.79,0,3.62.82,5.03,2.25,1.45,1.47,2.27,3.37,2.24,5.23-.05,4.13,1.78,8.38,5.02,11.65,3.32,3.35,7.68,5.28,11.98,5.28h.16c3.72,0,7.38,3.71,7.38,7.49.01,13.07.02,26.15,0,39.22,0,3.59-3.93,7.41-7.64,7.42-4.44.02-8.87,1.96-12.13,5.34-3.14,3.25-4.88,7.5-4.76,11.67.05,1.61-.84,3.55-2.3,5.06-1.4,1.44-3.12,2.3-4.61,2.3-22.44.01-44.87.02-67.31.02-24.17,0-48.34,0-72.51-.02-1.36,0-2.99-.83-4.38-2.23-1.53-1.54-2.48-3.48-2.47-5.07.03-4.97-1.78-8.98-5.53-12.26l-4.25-3.72-.35,5.63c-.14,2.27-.19,4.48-.24,6.62-.11,4.56-.21,8.87-1.16,12.84-.94,3.93-2.85,7.83-4.7,11.6-.84,1.71-1.7,3.47-2.47,5.24l-1.71,3.89h221.42v-148.31h-187.7Z"
              />
              <path
                fill="currentColor"
                d="m268.04,184.32l.46,4.03,3.59-1.89c.72-.38,1.42-.75,2.11-1.11,1.43-.75,2.8-1.47,4.16-2.21l36.61-20.02c17.86-9.77,35.71-19.53,53.57-29.29,1.06-.58,2.3-.89,3.59-.89,2.9,0,5.68,1.51,7.08,3.85,3.17,5.3,8.88,8.59,14.9,8.59,2.9,0,5.71-.79,8.13-2.27.58-.36,1.48-.56,2.53-.56,2.82,0,6,1.43,6.94,3.12,6.16,11.14,12.53,22.76,19.48,35.53,1.37,2.52-.37,7.9-3.15,9.76-2.01,1.34-3.58,3.02-5.4,4.97-.83.89-1.7,1.82-2.68,2.79l-4.18,4.13,5.84.6c.93.1,1.62.18,2.14.24.91.11,1.46.17,2.07.17,8.41,0,16.82.01,25.47.01h18.78s-64.01-116.67-64.01-116.67l-2.39,1.21c-.48.24-.93.47-1.36.68-.92.46-1.76.88-2.59,1.32l-3.67,2c-17.81,9.69-35.61,19.38-53.41,29.09-24.23,13.22-47.93,26.16-71.59,39.14-2.51,1.38-5.06,3.12-4.92,5.64.24,4.48.78,8.84,1.34,13.46.19,1.51.37,3.04.55,4.59Z"
              />
              <path
                fill="currentColor"
                d="m390.14,315.74c12.94-13.46,14.68-32.33,4.32-46.95-8.6-12.14-21.21-18.7-37.52-19.53l-.64-1.93-2.57.75c-2.23.65-4.57,1.23-6.84,1.79-5.14,1.27-10.46,2.57-15.34,4.91-12.14,5.81-20.36,16.13-22.55,28.31-2.11,11.76,1.74,23.72,10.55,32.82,8.7,8.98,21.53,14.13,35.19,14.13s26.65-5.21,35.39-14.29Z"
              />
              <path
                fill="currentColor"
                d="m341.84,170.47c-1.47-.17-2.99-.25-4.52-.25-19.45,0-39.81,13.31-45.38,29.67l-1.25,3.67h85.97l-.31-3.06c-1.59-15.55-15.78-27.9-34.5-30.03Z"
              />
              <path
                fill="currentColor"
                d="m426.74,306.85c9.38-.02,17.1-7.65,17.22-17,.06-4.64-1.73-9.04-5.03-12.38-3.28-3.32-7.62-5.16-12.24-5.16-9.36,0-17.07,7.65-17.19,17.05-.06,4.7,1.71,9.11,4.97,12.41,3.24,3.28,7.58,5.09,12.23,5.09h.05Z"
              />
              <path
                fill="currentColor"
                d="m394.91,160.6h-.26c-8.63,0-15.96,7.71-16.02,16.84-.03,4.65,1.77,9.05,5.07,12.38,3.2,3.23,7.39,5.02,11.8,5.04h.07c9.34,0,17.06-7.64,17.21-17.02.15-9.8-7.36-17.04-17.88-17.23Z"
              />
              <path
                fill="currentColor"
                d="m267.15,297.14l1.51,2.18c3.39,4.91,8.18,7.51,13.85,7.51.84,0,1.7-.06,2.57-.17,7-.92,12.06-5.19,14.24-12.03,1.93-6.04.63-11.94-3.56-16.19l-1.71-1.73-26.89,20.44Z"
              />
              <path
                fill="currentColor"
                d="m203.72,174.42c-5.56-2.18-11.02-3.84-16.25-4.94-5.23-1.1-10.56-2.04-15.72-2.95-4.82-.85-9.8-1.73-14.65-2.73-.35-.07-.95-.57-1.51-1.07.52-.62,1.17-1.33,1.49-1.42,3.59-.97,6.8-1.44,9.8-1.44,5.5,0,10.23,1.62,14.5,4.98,1.05.83,2.5,1.97,4.26,1.97.18,0,.36-.01.54-.04,4.87-.68,9.77-1.49,14.95-2.36,1.68-.28,3.4-.56,5.17-.86l5.13-.84-3.56-3.79c-8.98-9.58-19.66-10.95-29.99-12.27-.82-.1-1.64-.21-2.45-.32l-.82-5.45h-19.08l-.87,5.55c-.12.01-.25.02-.37.04-1.78.17-3.45.33-5.16.58-7.53,1.11-16.07,2.38-22.74,8.56-3.91,3.61-4.53,7.12-4.37,9.43.16,2.26,1.22,5.55,5.4,8.46,2.37,1.65,6.11,3.83,10.47,4.85,5.42,1.27,10.96,2.26,16.33,3.22,2.59.46,5.18.92,7.76,1.42,1.05.2,2.1.4,3.16.6,4.27.8,8.68,1.62,12.88,2.74.3.1.81.56,1.13.99-.35.37-.89.86-1.45,1.23-.97.64-2.26,1.06-3.35,1.11l-.67.03c-3.38.15-6.87.31-10.27.31-1.92,0-3.65-.05-5.3-.15-5.41-.33-8.87-1.92-11.23-5.17-1.08-1.48-3.17-2.15-4.76-2.15-.18,0-.35,0-.51.02-5.21.49-10.48,1.08-16.06,1.71l-10.62,1.18,3.13,3.93c9.39,11.79,21.7,13.3,33.6,14.75,1.03.13,2.05.25,3.07.38l.56,7.07h19.71l.53-7.18c.79-.07,1.52-.13,2.24-.21l.2-.02c8.98-.93,18.26-1.89,26.63-6.88,3.44-2.05,7.99-5.52,7.74-11.9-.2-4.97-3.26-8.87-8.62-10.97Z"
              />
            </svg>
            <p className="label">Dinero Real</p>
          </div>
          <p className="amount">${numberWithCommas(showBalance)}</p>
        </Row>
        <Row
          className="flx-btw-ctr"
          style={{ cursor: 'pointer' }}
          onClick={claim}>
          {isLoading ? (
            <Spinner spinnerSize={25} />
          ) : (
            <>
              <div className="flx-str-ctr">
                <svg
                  className="icon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512">
                  <path
                    fill="currentColor"
                    d="m432.57,303.1c-.14-13.34-5.79-25.01-16.34-33.76-8.08-6.7-17.39-10.1-27.66-10.1-.25,0-.49,0-.74,0l-3.09.05v-4.23c0-7.81-.25-12.81-3.71-16.26-3.46-3.45-8.45-3.7-16.27-3.7h-25.53s1.88-1.88,1.88-1.88c2.07-2.07,4.13-4.11,6.18-6.14,4.91-4.86,9.99-9.89,14.81-14.98,4.65-4.91,4.7-11.61.14-17.07-1.87-2.23-1.86-3.4.05-5.69,4.55-5.46,4.45-12.16-.26-17.08-4.93-5.15-10.11-10.21-14.69-14.68-1.8-1.76-3.54-3.46-5.19-5.09l-3.47-3.43-18.75,18.07,3.7,3.6c1.07,1.04,2.16,2.12,3.28,3.21,2.87,2.82,5.84,5.74,8.93,8.62.34.31.45.48.46.48,0,.06.05.4-.13,1.38-.93,5.01-.93,10.36-.01,15.48.19,1.06.14,1.4.15,1.4,0,0,0,0,0,0,0,0-.09.16-.44.48-3.25,2.99-6.36,6.01-9.37,8.94-1.17,1.14-2.31,2.25-3.42,3.32l-2.74,2.64c-2.86-23.08-14.1-40.47-33.49-51.75-8.86-5.15-17.9-8.34-26.97-9.52l1.94-2.03c1.22-1.28,2.42-2.56,3.61-3.83,3.03-3.23,5.9-6.28,8.94-9.13.3-.09.98-.21,2.49-.27,2.68-.11,5.31-.16,7.84-.16,2.2,0,4.38.04,6.48.12,1.47.06,2.15.25,2.38.33,3.04,2.88,5.9,5.96,8.93,9.21,1.18,1.27,2.38,2.55,3.59,3.83l3.53,3.73,18.91-18.92-3.56-3.54c-2.03-2.01-4.04-4.02-6.04-6.02-4.79-4.79-9.74-9.74-14.72-14.49-2.6-2.48-5.67-3.8-8.88-3.8-2.88,0-5.71,1.08-8.18,3.13-1.25,1.04-2.32,1.56-3.18,1.56s-2.03-.57-3.36-1.68c-2.41-2.01-5.2-3.07-8.08-3.07s-5.91,1.21-8.19,3.41c-5.18,4.98-10.23,10.18-15.11,15.2-1.96,2.02-3.92,4.04-5.88,6.03l-3.46,3.52,16.36,16.47c-1.47-.11-2.93-.16-4.4-.16-12.77,0-25.44,3.99-37.64,11.85-19.65,12.66-30.13,31.81-31.15,56.9l-.21,5.2h25.64l.3-4.68c1.8-27.8,22.67-42.64,42.36-42.93.26,0,.53,0,.79,0,23.29,0,39.12,15.82,43.43,43.41l.66,4.23h25.18l-.26-5.25c-.09-1.73-.22-3.43-.39-5.1l15.21,16.6h-89.95c-37.84,0-75.67,0-113.51-.02l151.22-151.25,109.18,109.11-25.29,24.98,18.19,18.8,12.47-12.49c6.89-6.9,13.71-13.73,20.53-20.57,8.25-8.28,8.25-14.72,0-22.97-40.94-40.95-81.88-81.89-122.82-122.84-3.95-3.95-7.48-6.58-11.87-6.58s-7.88,2.61-11.79,6.53c-5.11,5.11-10.23,10.23-15.34,15.34v-21.76h-40.44c-19.1,0-38.19,0-57.28,0-11.15,0-15.9,4.8-15.91,16.02,0,29.26,0,58.52,0,87.78,0,1.25.07,2.47.14,3.54.03.45.05.89.07,1.32l.22,4.77h21.53c-9.35,9.35-18.7,18.71-28.05,28.06v-22.96l-5.6.67c-2.05.25-4.13.42-6.13.59-4.48.37-9.12.76-13.61,1.99-19.69,5.39-32.43,22.64-32.44,43.96-.04,50.99-.04,102.84-.03,152.98v42.16c0,29.91,18.6,48.48,48.52,48.48h198.6c4.33,0,21.62-.02,25.95-.02,5.98,0,11.96,0,17.94.04h.12c8.14,0,13.51-4.29,14.03-11.18.45-6.12.36-12.26.26-18.19-.04-2.45-.08-4.9-.08-7.35v-5h-25.91v15.72h-84.17c-49.27,0-98.54,0-147.82-.01-14.04,0-21.46-7.52-21.46-21.74,0-36.24,0-72.48,0-108.72v-47.57c9.58,4.38,19.34,4.38,26.92,4.38h3.09c37.19-.05,74.4-.06,111.59-.06h112.06v55.61h25.84v-33.43l1.45.53c1.47.54,2.9.99,4.28,1.43,2.66.85,5.17,1.65,7.21,2.81,7.02,3.98,10.45,12.45,8.34,20.58-2.24,8.64-9.34,14.26-18.07,14.31-5.99.04-11.98.05-17.98.05-5.1,0-10.2,0-15.31-.02-5.11,0-10.21-.02-15.32-.02-9.27,0-16.8.03-23.72.09-25.17.22-44.8,20.06-44.7,45.18.1,24.41,20.18,44.42,44.76,44.6,12.46.09,24.73.14,36.46.14s24.31-.05,35.92-.15c24.68-.21,44.23-19.65,44.5-44.24.23-20.6.22-42.01-.02-65.44ZM201,123.94c-.22-1.54-.27-1.91,1.76-2.92,3.94-1.96,7.6-5.55,9.57-9.36,1.31-2.55,2.07-2.55,2.8-2.55.34,0,.73.04,1.17.12.46.08.92.12,1.4.12.68,0,1.29-.08,1.78-.15.2-.03.41-.06.63-.07l.77-.06c-6.6,6.6-13.21,13.21-19.81,19.81v-.77c0-.46.01-.86.02-1.23.03-.92.06-1.88-.09-2.94Zm-31.69-46.63h83.32c-9.3,9.3-18.59,18.6-27.89,27.9v-21.81h-5c-1.68,0-3.33-.02-4.96-.03-1.63-.02-3.25-.03-4.85-.03-2.52,0-4.6.04-6.54.13-6.71.31-11.46,4.76-12.11,11.32-.37,3.72-1.45,4.44-4.5,4.7-6.41.55-11.01,5.12-11.46,11.35-.3,4.1-.23,8.22-.17,12.2.03,1.68.05,3.37.05,5.07v5h21.65c-9.18,9.18-18.36,18.36-27.54,27.54v-83.34Zm-50.35,133.71c-.9.9-1.78,1.83-2.62,2.73-.35.38-.7.75-1.04,1.11l-3.31,3.48,16.25,16.75c-1,0-2,0-2.99,0-5.77,0-10.99-2.06-14.69-5.8-3.46-3.49-5.34-8.23-5.3-13.34.09-10.6,8.69-18.66,20.02-18.75.81,0,1.62,0,2.44,0h5.07c-4.61,4.61-9.22,9.22-13.82,13.83Zm177.95,156.54c.13-10.15,8.5-18.47,18.67-18.55,12.38-.09,23.6-.14,34.3-.14,11.26,0,21.7.05,31.93.15.38,0,.77,0,1.15,0,7.18,0,15.33-.62,23.68-4.39,0,.84.02,1.68.03,2.51.1,7.95.2,15.45-.22,22.89-.52,9.14-8.58,16.66-17.98,16.75-12.35.12-24.79.18-36.96.18s-24.3-.06-36.24-.18c-4.9-.05-9.48-2.01-12.92-5.51-3.57-3.66-5.51-8.52-5.44-13.71Z"
                  />
                  <rect
                    fill="currentColor"
                    x="303.12"
                    y="355.13"
                    width="25.38"
                    height="25.47"
                  />
                </svg>
                <p className="label">Dinero Promo</p>
              </div>
              <p className="amount">${numberWithCommas(promoBalance)}</p>
            </>
          )}
        </Row>
      </Dropdown> */}
    </div>
  )
}

export default BalanceBreakdown
